<template>
    <div>
        <h4>
            Полка {{shelf}}, стойка {{rack}}
        </h4>

        <div>
            Обновите страницу, чтобы начать калибровку сначала
        </div>

        <hr>

        <last-error-block></last-error-block>

        <template v-if="rawValues !== null">
            <div style="font-weight: bold;">
                "Сырые" значения
            </div>
            <div>
                {{rawValues}}
            </div>
            <hr>
        </template>

        <div style="font-weight: bold;">
            Текущий шаг:
        </div>
        <div v-if="step == steps.STEP_WAITING_ZERO">
            <div>
                Уберите всё с полки и нажмите "Продолжить"
            </div>
            <div>
                <button @click="storeValues()">Продолжить</button>
            </div>
        </div>

        <div v-if="step == steps.STEP_WAITING_WEIGHT">
            <div>
                Положите что-нибудь на весы, введите вес продукта <b>в граммах</b>, затем нажмите кнопку "Отправить"
            </div>
            <div v-show="!isWaitingAnswer">
                <input v-model="weight"> <button @click="sendWeight()">Отправить</button>
            </div>
            <div>
                <div>
                    Быстрый ввод веса:
                </div>
                <div class="predefined-weight-block">
                    <div class="predefined-weight" v-for="v in predefinedWeights">
                        <button :disabled="isWaitingAnswer" @click="setWeight(v)">{{v}} г</button>
                    </div>
                </div>
            </div>
        </div>

        <hr>
        <div style="font-weight: bold;">
            Итого:
        </div>

        <div>
            <div>
                Записано значений: {{valuesCount}}
            </div>
            <div v-if="valuesCount < MIN_VALUES_COUNT" style="color: red;">
                Требуется значений: не менее {{MIN_VALUES_COUNT}}
            </div>
            <div v-if="valuesCount >= MIN_VALUES_COUNT">
                <button @click="saveCalibration()">Сохранить калибровку</button>
            </div>
        </div>

        <div v-if="isWaitingAnswer">
            Ожидание ответа от холодильника...
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import fridgeRabbit from "../utils/rabbit/fridge_rabbit";
    import LastErrorBlock from "../components/LastErrorBlock";

    const RABBIT_ACTION = 'calibrate_scales_shelf';
    const MIN_VALUES_COUNT = 3;

    const STEP_WAITING_ZERO = 'st_wait_zero';
    const STEP_WAITING_WEIGHT = 'st_wait_weight';

    export default {
        name: "CalibrateScalesShelf",
        components: {LastErrorBlock},
        props: ['shelf', 'rack'],
        computed: {
            predefinedWeights() {
                return [200, 400, 500, 1000];
            },
            steps() {
                return {STEP_WAITING_ZERO, STEP_WAITING_WEIGHT};
            },
            MIN_VALUES_COUNT() {
                return MIN_VALUES_COUNT;
            },
        },
        methods: {
            ...mapActions('app', {
                setLastError: 'setLastError',
                clearLastError: 'clearLastError',
            }),
            onAnswer(data) {
                console.log('data', data);
                this.isWaitingAnswer = false;
                if(!data) {
                    return;
                }

                if(!data.success) {
                    this.setLastError(data.error);
                } else {
                    this.clearLastError();
                    if(typeof this.onRabbitCallback === 'function') {
                        this.onRabbitCallback(data);
                    }
                }
                if(data.start_calibrate) {
                    this.step = STEP_WAITING_ZERO;
                }
                if(data.values_count) {
                    this.valuesCount = data.values_count;
                }
                if(data.raw_values) {
                    this.rawValues = data.raw_values;
                }
            },
            async sendWeight() {
                this.onRabbitCallback = () => {
                    this.weight = '';
                    this.step = STEP_WAITING_ZERO;
                };
                this.isWaitingAnswer = true;
                await fridgeRabbit.send(RABBIT_ACTION, {weight: this.weight});
            },
            async storeValues() {
                this.onRabbitCallback = () => {
                    this.step = STEP_WAITING_WEIGHT
                };
                this.isWaitingAnswer = true;
                await fridgeRabbit.send(RABBIT_ACTION, {is_zero: true});
            },
            async saveCalibration() {
                this.onRabbitCallback = () => {
                    this.$router.push({name: 'test_scales_shelf'});
                };
                this.isWaitingAnswer = true;
                await fridgeRabbit.send(RABBIT_ACTION, {save: true});
            },
            setWeight(value) {
                if(this.isWaitingAnswer) {
                    return;
                }
                this.weight = `${value}`;
                this.sendWeight();
            },
        },
        data() {
            return {
                isWaitingAnswer: false,
                step: '',
                weight: '',
                valuesCount: 0,
                onRabbitCallback: null,
                rawValues: null,
            };
        },
        async mounted() {
            await fridgeRabbit.listen(this.onAnswer);
            this.isWaitingAnswer = true;
            fridgeRabbit.send(RABBIT_ACTION, {shelf: this.shelf, rack: this.rack});
        },
        destroyed() {
            fridgeRabbit.clear();
            this.clearLastError();
        },
    }
</script>

<style scoped>
    .predefined-weight-block {
        display: flex;
    }
    .predefined-weight {
        padding: 0 30px;
    }
</style>
